import { useState,useEffect ,useRef} from 'react'; 
import { styled } from '@mui/material/styles';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Fade } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import {  accordionDetailsClasses } from "@mui/material/Accordion";
import { accordionClasses,accordionDetailsClasses } from "@mui/material";
const BorderLinearProgress = styled(LinearProgress)(({ ownerState }) => ({
  height: 15,
  backgroundColor: ownerState.trackColor || "#e0e0e0",
  borderRadius: 8,
  [`& .${linearProgressClasses.bar}`]: {
    backgroundColor: ownerState.barColor || "#ff7675",
    borderRadius: 8,
  },
}));

export default function CustomProgress({ value, trackColor, barColor, sx }) {
  const [progress, setProgress] = useState(0);
  const progressRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          let currentValue = 0;
          const interval = setInterval(() => {
            currentValue += 5;
            if (currentValue >= value) {
              setProgress(value);
              clearInterval(interval);
            } else {
              setProgress(currentValue);
            }
          }, 50);
        }
      },
      { threshold: 0.5 } // 50% visible hone par trigger hoga
    );

    if (progressRef.current) {
      observer.observe(progressRef.current);
    }

    return () => {
      if (progressRef.current) {
        observer.unobserve(progressRef.current);
      }
    };
  }, [value]);

  return (
    <div ref={progressRef} style={{ width: "100%" }}>
      <BorderLinearProgress
        variant="determinate"
        value={progress}
        sx={sx}
        ownerState={{ trackColor, barColor }}
      />
    </div>
  );
}
export const CustomAccordion = ({ summary, details, useFade = false }) => {
    const [expanded, setExpanded] = useState(false);
  
    const handleExpansion = () => {
      setExpanded((prev) => !prev);
    };
  
    return (
      <Accordion
        expanded={expanded}
        onChange={handleExpansion}
        slots={useFade ? { transition: Fade } : {}}
        slotProps={useFade ? { transition: { timeout: 400 } } : {}}
        sx={[
          expanded
            ? {
                [`& .${accordionClasses.region}`]: { height: "auto" },
                [`& .${accordionDetailsClasses.root}`]: { display: "block" },
              }
            : {
                [`& .${accordionClasses.region}`]: { height: 0 },
                [`& .${accordionDetailsClasses.root}`]: { display: "none" },
              },
        ]}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="span">{summary}</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ backgroundColor: "#bcdade" }}>
          <Typography>{details}</Typography>
        </AccordionDetails>
      </Accordion>
    );
  };